/**
 * 认证相关 API
 */

import apiClient from './client';
import { LoginRequest, LoginResponse, User, ApiResponse } from '../types';

/**
 * 登录
 */
export const login = async (data: LoginRequest): Promise<LoginResponse> => {
  const response = await apiClient.post<LoginResponse>('/auth/login', data);
  return response.data;
};

/**
 * 获取当前用户信息
 */
export const getCurrentUser = async (): Promise<User> => {
  const response = await apiClient.get<ApiResponse<User>>('/auth/me');
  if (!response.data.success || !response.data.data) {
    throw new Error('获取用户信息失败');
  }
  return response.data.data;
};

/**
 * 登出（前端操作，清除本地存储）
 */
export const logout = (): void => {
  // 如果后端有登出接口，可以在这里调用
  // await apiClient.post('/auth/logout');
};

